import { AiOutlineAlignRight } from "react-icons/ai";
import { useGetUserMe } from "../features/user";

export const Navbar: React.FC<{ toggleSidebar: () => void }> = ({
  toggleSidebar,
}) => {
  const { userMe } = useGetUserMe();

  return (
    <nav className="flex items-center justify-between shadow-sm p-4 bg-white text-black z-50">
      <AiOutlineAlignRight
        size={25}
        color="gray"
        className="cursor-pointer"
        onClick={toggleSidebar}
      />

      {/* <h1 className="text-base ml-4">Karunia Seluler Persada</h1> */}
      <div>
        {userMe?.role !== "USER" && userMe?.name}
        {/* <AiOutlineMore size={25} color="gray" className="cursor-pointer" /> */}
      </div>
    </nav>
  );
};
